module.exports = __webpack_public_path__ + "img/bgc.da18300e.png";